﻿<div class="container" *ngIf="!(appState.isLoggedIn.obs$ | async)">
    <h4 class="text-center">{{ title }}</h4>
</div>